import { useEffect, useRef } from "react";
import { Bath, Brush, Droplet, Droplets, Eye, FlaskConical, Flame, Flower2, Gift, Heart, LayoutGrid, Package, Shirt, Sparkles, Sun, Tag, VenetianMask, Waves } from "lucide-react";

const ICONS = {
  All: LayoutGrid, Skincare: Sparkles, "Waxing & Hair Removal": Flame, Lips: Heart, "Eyes & Brows": Eye, "Bath & Body": Bath,
  "Intimate Care": Flower2, Masks: VenetianMask, "Tools & Accessories": Brush, "Sets & Gifts": Gift, "Spa Supplies": Package, "Apparel & Home": Shirt,
};
const KEYWORDS = [[/serum|oil|ampoule/i, Droplet], [/moistur|cream|lotion/i, Droplets], [/clean|wash/i, Waves], [/toner|essence|acid/i, FlaskConical],
  [/sun|spf/i, Sun], [/eye|brow|lash/i, Eye], [/lip/i, Heart], [/wax|hair/i, Flame], [/mask/i, VenetianMask], [/gift|set/i, Gift], [/body|bath/i, Bath]];
const iconFor = (c) => ICONS[c] || KEYWORDS.find(([re]) => re.test(c))?.[1] || Tag;
const slug = (s) => s.toLowerCase().replace(/[^a-z0-9]+/g, "-");

export const ShopTabs = ({ cats, data, filter, setFilter }) => {
  const bar = useRef(null);
  useEffect(() => {
    bar.current?.querySelector('[aria-selected="true"]')?.scrollIntoView({ behavior: "smooth", inline: "center", block: "nearest" });
  }, [filter]);
  const count = (c) => (c === "All" ? data.length : data.filter((p) => p.category === c).length);
  return (
    <div className="shop-tabs" role="tablist" aria-label="Shop categories" ref={bar} data-testid="shop-filters">
      {cats.map((c) => {
        const Icon = iconFor(c);
        return (
          <button key={c} type="button" role="tab" aria-selected={filter === c} className="shop-tab" onClick={() => setFilter(c)} data-testid={`shop-filter-${slug(c)}`}>
            <span className="shop-tab-icon"><Icon size={20} strokeWidth={1.6} /></span>
            <span className="shop-tab-label">{c}</span>
            <small>{count(c)}</small>
          </button>
        );
      })}
    </div>
  );
};
